export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=701a52c050e3dbe5f21943099537eca8c61a746038&name=pushAdClickData!'